"use client";

import {useEffect, useRef} from "react";

import {usePathname, useSearchParams} from "next/navigation";

declare global {
    interface Window {
        analytics?: {
            page: (...args: Array<unknown>) => void;
        };
    }
}

export function SegmentPageTracker(): null {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const isFirstRender = useRef(true);

    useEffect(() => {
        // Skip the first render — the inline snippet already calls analytics.page() on initial load
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        window.analytics?.page();
    }, [pathname, searchParams]);

    return null;
}
